export { MagazineTeasersList } from './MagazineTeasersList';
export { MagazineTeaser } from './MagazineTeaser';
